// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/arrow-down.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'arrow-down',
  version: 'solid',
  paths: [
    {
      d: 'M12 3.6a.9.9 0 0 1 .9.9v12.7656l4.752-4.9896a.9.9 0 1 1 1.296 1.248l-6.3 6.6a.9.9 0 0 1-1.296 0l-6.3-6.6a.9.9 0 1 1 1.296-1.248l4.752 4.9896V4.5a.9.9 0 0 1 .9-.9',
      fillRule: 'evenodd',
    },
  ],
}
